var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.valueTooltip),expression:"valueTooltip"}],staticClass:"font-medium text-sm ml-2",class:{'text-green': _vm.type === 'income',
              'text-red':   _vm.type === 'expense',
              'text-yellow':_vm.type === 'transfer'}},[_vm._v(" "+_vm._s(_vm.valueDisplay)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }